<template>
  <div>
    <b-button
      id="id-video-request-btn"
      type="button"
      pill
      variant="outline-info"
      class="btn btn-rounded btn-light btn-block"
      :disabled="!generalConditionForCTA"
      @click.prevent="videoRequest()"
    >
      <b-icon-camera-video />&nbsp;&nbsp;Video Request
    </b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { EventBus } from "@/events/eventBus";
import NewVideoRequestForm from "@/components/conversations/NewVideoRequestForm";

export default {
  props: {
    conversationId: String,
    recipientId: String,
    recipientLabel: String,
    recipientLanguage: String,
  },
  computed: {
    ...mapGetters("user", ["currentToken", "currentUser"]),
    ...mapGetters("agency", ["currentAgency", "agencySettings"]),
    ...mapGetters("conversations", ["currentConversation"]),
    generalConditionForCTA() {
      const { status, operator_id } = this.currentConversation;
      const { enableConversationAssignment } = this.agencySettings;

      if (status === "active") {
        if (enableConversationAssignment === false) {
          return true;
        }
        if (enableConversationAssignment === true && (operator_id === this.currentUser.user_id || (operator_id !== null && this.$permission("admin:agency")))) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    async videoRequest() {
      const $ = window.$;
      $("#id-modal-container").modal({
        backdrop: "static"
      });
      EventBus.$emit("open", {
        component: NewVideoRequestForm,
        title: "Send Video Request",
        actionButton: "Send",
        closeOnClick: false,
        props: {
          conversationId: this.conversationId,
          recipientId: this.recipientId,
          recipientLabel: this.recipientLabel,
          recipientLanguage: this.recipientLanguage
        }
      });
    }
  }
};
</script>
